import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useProfile } from '../../context/ProfileContext';
import DropdownMenu from '../DropdownMenu/DropdownMenu';
import ProfileDialog from '../ProfileDialog/ProfileDialog';
import './UserProfile.css';
// @ts-ignore
import profileIcon from '../../image-assets/icon.profile.svg';
// @ts-ignore
import editIcon from '../../image-assets/icon.edit.svg';

interface UserProfileProps {
  className?: string;
}

const UserProfile: React.FC<UserProfileProps> = ({ className = '' }) => {
  const { user, signOut } = useAuth();
  const { profileData } = useProfile();
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isProfileDialogOpen, setIsProfileDialogOpen] = useState(false);

  // Get user's name from profile data, metadata, or use email as fallback
  const getUserName = () => {
    if (!user) return 'Guest';
    
    // First try to get name from profile data (from the database)
    if (profileData) {
      if (profileData.first_name && profileData.last_name) {
        return `${profileData.first_name} ${profileData.last_name}`;
      } else if (profileData.first_name) {
        return profileData.first_name;
      } else if (profileData.last_name) {
        return profileData.last_name;
      }
    }
    
    // If not in profile, try to get name from user metadata
    const name = user.user_metadata?.name;
    if (name) {
      return name;
    }
    
    // If no name, use email (and truncate it if needed)
    const email = user.email;
    if (email) {
      // Return just the part before @ in the email
      return email.split('@')[0];
    }
    
    return 'User';
  };

  const toggleUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      window.location.href = '/login';
    } catch (error) {
      // Handle error silently
    }
  };

  const handleOpenProfileDialog = () => {
    setIsProfileDialogOpen(true);
    setIsUserDropdownOpen(false); // Close the dropdown when opening the dialog
  };

  const handleCloseProfileDialog = () => {
    setIsProfileDialogOpen(false);
  };

  // Create user dropdown items
  const userItems = [
    {
      id: 'edit-profile',
      label: 'Edit Profile',
      icon: editIcon,
      iconPosition: 'right' as const,
      onClick: handleOpenProfileDialog
    },
    // {
    //   id: 'settings',
    //   label: 'Settings',
    //   icon: settingsIcon,
    //   iconPosition: 'right' as const,
    //   onClick: () => {}
    // }, // Remove settings item
    {
      id: 'signout',
      label: 'Sign Out',
      onClick: handleSignOut,
      className: 'sign-out-item'
    }
  ];

  return (
    <div className={`user-profile ${className}`}>
      <div 
        className="user-profile-container"
        onClick={toggleUserDropdown}
      >
        <span className="user-name-display">
          {getUserName()}
        </span>
        <div className="nav-user-button">
          <img src={profileIcon} alt="Profile" className="profile-icon" />
        </div>
      </div>
      
      <DropdownMenu 
        isOpen={isUserDropdownOpen}
        items={userItems}
        position="right"
      />

      {isProfileDialogOpen && user && (
        <ProfileDialog
          isOpen={isProfileDialogOpen}
          onClose={handleCloseProfileDialog}
        />
      )}
    </div>
  );
};

export default UserProfile; 